
export enum ConnectionStatusEnum {

    Pending = 1,
    Approved = 2,
    Rejected = 3,
    Connected = 4,
    Disconnected = 5


}